import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { ScrollableContainer } from "@/components/ui/scrollbar";
import { MobilePageTitle } from "@/components/ui/mobile-page-title";

export const Route = createFileRoute("/(protected)/challenges/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation();

  return (
    <ScrollableContainer>
      <div className="flex h-full flex-col">
        <MobilePageTitle className="mt-5 mb-4">
          {t("pages:dashboard.sidebar.challenges")}
        </MobilePageTitle>
        <div className="p-6">{t("common:coming_soon")}</div>
      </div>
    </ScrollableContainer>
  );
}
